import { Tooltip, Text, CARET_PLACEMENTS, useIsBreakpointLargeAndUp, usePercent } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent, ReactNode } from 'react'
import { useAppRouter, useOfferDetailPCL, useRatesConfig } from '../../../../state'
import { useCheckoutSizes } from '../../../../utils/responsive'

import styles from './style.module.css'

interface PCLToolipProps {
  buttonRef: React.MutableRefObject<any>
  setHasClickedOutside: (bool: boolean) => void
  onClose: () => void
  tooltipId: string
}

export const PCLTooltip: FunctionComponent<PCLToolipProps> = ({ tooltipId, buttonRef, setHasClickedOutside, onClose }) => {
  const { textSize } = useCheckoutSizes()
  const isDesktop = useIsBreakpointLargeAndUp()
  const { t } = useTranslation()
  const { locale } = useAppRouter()
  const { formatPercent } = usePercent({ locale, decimalPlaces: 2, shouldDivideBy100: true })
  const { apr } = useOfferDetailPCL() ?? {}
  const { maxComparisonRate, minComparisonRate, maxInterestRate: maximumApr } = useRatesConfig()

  const payInMoreAprHelpText = (): string => {
    const minimumApr = formatPercent(apr)

    return t('consumerLending:paymentOptions.payInMoreAPRHelp', {
      minimumApr,
      maximumApr,
      minComparisonRate,
      maxComparisonRate,
    })
  }

  const renderTooltipContent = (): ReactNode => {
    return <Text size={textSize}>{payInMoreAprHelpText()}</Text>
  }

  return (
    <div className={styles.tooltipWrapper}>
      <Tooltip
        id={tooltipId}
        triggerRef={buttonRef}
        caretPlacement={CARET_PLACEMENTS.BOTTOM}
        testNameSpace='payInMoreAPR-terms-tooltip'
        usePortal={false}
        content={renderTooltipContent()}
        hasCaret={true}
        onClose={onClose}
        useMobileView={!isDesktop}
        bubbleSize={{ width: isDesktop ? '93%' : '100%' }}
        skidding={isDesktop ? -150 : 85}
        closeOnOutsideClick={setHasClickedOutside}
      />
    </div>
  )
}
